const mixin = {
  computed: {
    isAuthenticated () {
      return this.$auth.isAuthenticated && !this.$auth.loading
    }
  },


  methods: {
    login (redirectRoute = 'home') {
      const targetRoute = this.$router.resolve({ name: redirectRoute })
      this.$auth.loginWithRedirect({ appState: { targetUrl: targetRoute.href } })
    },

    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      })
      localStorage.clear()
    }
  }
}


export default mixin
